import { getCommonCompanyInfoList } from 'api/billing/billingOperation';
import { getCompanyBankHyperTapOption } from 'api/common/companyInfo';

const state = {
  // 公司实体名称数组
  companyEntityList: [],
  // 公司平台名称数组
  companyPlatformList: [],
  // 公司平台关联数组
  companyPlatformEntities: [],
  companyInfoLoading: false,
  hyperTapCompanyInfoLoading: false,
  hyperTapCompanyInfo: [],
  hyperTapCompanyEntities: [],
};

const mutations = {
  SET_COMPANY_PLATFORM: (state, companyPlatformList) => {
    state.companyPlatformList = companyPlatformList;
  },
  SET_COMPANY_ENTITY: (state, companyEntityList) => {
    state.companyEntityList = companyEntityList;
  },
  SET_COMPANY_PLATFORM_ENTITIES: (state, companyPlatformEntities) => {
    state.companyPlatformEntities = companyPlatformEntities;
  },
  SET_LOADING(state, loading) {
    state.companyInfoLoading = loading;
  },
  SET_HYPER_TAP_LOADING(state, loading) {
    state.hyperTapCompanyInfoLoading = loading;
  },
  SET_HYPER_TAP_COMPANY(state, hyperTapCompanyInfo) {
    state.hyperTapCompanyInfo = hyperTapCompanyInfo;
  },
  SET_HYPER_TAP_COMPANY_ENTITY(state, hyperTapCompanyEntities) {
    state.hyperTapCompanyEntities = hyperTapCompanyEntities;
  },
  CLEAR: (state) => {
    state.companyPlatformList = [];
    state.companyEntityList = [];
    state.companyPlatformEntities = [];
    state.companyInfoLoading = false;
  },
};

const actions = {
  fetchCompanyInfo({ commit }) {
    commit('SET_LOADING', true);
    getCommonCompanyInfoList()
      .then((res) => {
        if (res && res.result) {
          const result = res.result;
          let companyPlatformList = [];
          let companyEntityList = [];
          result.forEach((item) => {
            companyPlatformList.push(item.companyPlatform);
            companyEntityList = companyEntityList.concat(item.companyEntityList);
          });
          commit('SET_COMPANY_PLATFORM_ENTITIES', result);
          commit('SET_COMPANY_PLATFORM', companyPlatformList);
          commit('SET_COMPANY_ENTITY', companyEntityList);
        }
      })
      .finally(() => {
        commit('SET_LOADING', false);
      });
  },
  fetchHyperTapCompanyInfo({ commit }) {
    commit('SET_HYPER_TAP_LOADING', true);
    getCompanyBankHyperTapOption()
      .then((res) => {
        if (res && res.result) {
          const result = res.result;
          let companyEntityList = [];
          result.forEach((item) => {
            companyEntityList.push({
              companyEntity: item.companyEntity,
              companyEntityAlias: item.companyEntityAlias,
              bfiId: item.bfiId,
            });
          });
          commit('SET_HYPER_TAP_COMPANY', result);
          commit('SET_HYPER_TAP_COMPANY_ENTITY', companyEntityList);
        }
      })
      .finally(() => {
        commit('SET_HYPER_TAP_LOADING', false);
      });
  },
  getCompanyInfo({ dispatch, state }) {
    if (state['companyPlatformList'].length > 0 || state['companyInfoLoading']) {
      return;
    }
    dispatch('fetchCompanyInfo');
  },
  getHyperTapCompanyInfo({ dispatch, state }) {
    if (state['hyperTapCompanyInfo'].length > 0 || state['hyperTapCompanyInfoLoading']) {
      return;
    }
    dispatch('fetchHyperTapCompanyInfo');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
